/**
 * Build-time configuration, sourced from Vite env vars.
 *
 * Local dev: put values in `web/.env.local` (gitignored).
 * Cloudflare Pages: set them in Project → Settings → Environment variables.
 *
 * The OAuth client ID is PUBLIC by design — browser bundles ship it in plain
 * text. Security comes from the GCP "authorized JavaScript origins" allow-list,
 * not from hiding the ID.
 */

export const GOOGLE_OAUTH_CLIENT_ID: string =
  (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '';

export function isGoogleSyncConfigured(): boolean {
  return GOOGLE_OAUTH_CLIENT_ID.length > 0;
}
